import { customElement, FASTElement, observable, attr, DOM } from '@microsoft/fast-element';
import { ClosePopupTemplate as template } from './close-popup.template';
import { ClosePopupStyles as styles } from './close-popup.styles';
import { Dialog } from '@microsoft/fast-foundation';

const name = 'close-popup';

@customElement({
  name,
  template,
  styles,
})
export class ClosePopup extends FASTElement {
  @observable public closeDialog: Dialog;
  @attr header: string = '';
  @attr description: string = '';

  cancelCloseDialog() {
    this.$emit('closeModal', false);
  }

  confirmCloseDialog() {
    this.$emit('closeModal', true);
  }
}
